export default __webpack_public_path__ + "static/6-43af267eed0ec3c080722cc4fa74e5e9.webp";